import React, { memo, useState } from 'react'
import { useIntl } from 'react-intl'
import TextField from '@mui/material/TextField'
import clsx from 'clsx'
import Grid from '@mui/material/Grid2'
import { setFilter } from 'redux/modules/search'
import { useDispatch } from 'react-redux'
// import { useRouter } from 'next/router'
// import useNonInitialEffect from 'hooks/useNonInitialEffect'
// import SearchRounded from '@mui/icons-material/SearchRounded'
import InputAdornment from '@mui/material/InputAdornment'
// import Button from '@mui/material/Button'
import CurrentFilter from 'components/SRP/Filters/CurrentFilter'
import sx from './styles'

const SearchForm = ({
  testVariant,
  // handleClickModal
}) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState('')
  const { formatMessage: f } = useIntl()
  // const router = useRouter()

  // const basePath = f({ id: 'ROUTE_SEARCH' })

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(setFilter({
      key: 'q',
      value,
    }))
    setValue('')
  }

  // useNonInitialEffect(() => {
  //   if (value === '') {
  //     router.push(basePath, null, { shallow: true })
  //   }
  // }, [value])

  return (
    <Grid sx={sx.root}>
      <Grid
        size={{
          xs: 10,
          md: testVariant ? 12 : 9,
        }}
        component="form"
        action=""
        onSubmit={(e) => handleSubmit(e)}
      >
        <TextField
          InputProps={{
            inputMode: 'search',
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={(e) => handleSubmit(e)}
                sx={sx.inputAdornment}
                className={clsx({
                  selected: Boolean(value),
                })}
              >
                {/* <SearchRounded
                  color="secondary"
                  sx={sx.searchIcon}
                /> */}
              </InputAdornment>
            ),
          }}
          sx={sx.searchBar}
          placeholder={f({
            id: 'SEARCH_FORM_LABEL',
          })}
          type="search"
          value={value}
          onChange={(e) => {
            setValue(e.target.value)
          }}
          fullWidth
          className={clsx('Mui-style', { touched: value })}
          id="outlined-search"
          variant="outlined"
        />
      </Grid>
      {
        !testVariant && (
          <Grid size={1}>
            {/* <Button
          id="search-btn"
          fullWidth
          variant="special"
          sx={sx.btn}
          disabled={!search}
          onClick={() => handleSubmit()}
        >
          <FormattedMessage id="SEARCH_BTN_CTA" />
        </Button> */}

            <CurrentFilter handleClickModal={(e) => handleSubmit(e)} />
          </Grid>
        )
      }
    </Grid>
  )
}

export default memo(SearchForm)
